import { Component, OnInit,NgZone } from '@angular/core';
import { Router } from "@angular/router";

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css']
})
export class AuthComponent implements OnInit {
  url:any;
  constructor(private router: Router, private zone: NgZone) {
    this.url = decodeURIComponent(router.url);
   }

  ngOnInit() {
  }

  navigate(){
    if(this.url != "/auth/saveUsername"){
      this.zone.run(()=>{
        this.router.navigate(['/']);
      });
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/auth/auth.component.ts